import styled from 'styled-components';
import { EmailHintProps } from './types';

export const EmailHint = styled.div.attrs({ 'data-test': 'EmailHint' })<
  EmailHintProps
>`
  && {
    margin: 0.5rem 0;

    display: ${p => (p.visible ? `block` : 'none')};

    a {
      text-decoration: underline !important;
      ${p => p.discreetLink && `color: ${p.theme.colors.base500};`}
    }

    ${p => p.error && `color: ${p.theme.colors.negative700};`}

    p {
      margin: 0;
    }
  }
`;
